"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessStatusToJSON = exports.BusinessStatusFromJSONTyped = exports.BusinessStatusFromJSON = exports.BusinessStatus = void 0;
/**
 * The status of the business.
 * @export
 */
exports.BusinessStatus = {
    Active: 'ACTIVE'
};
function BusinessStatusFromJSON(json) {
    return BusinessStatusFromJSONTyped(json, false);
}
exports.BusinessStatusFromJSON = BusinessStatusFromJSON;
function BusinessStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BusinessStatusFromJSONTyped = BusinessStatusFromJSONTyped;
function BusinessStatusToJSON(value) {
    return value;
}
exports.BusinessStatusToJSON = BusinessStatusToJSON;
